"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbortSignal = exports.AbortController = void 0;
const cjs_ponyfill_1 = require("abortcontroller-polyfill/dist/cjs-ponyfill");
var getGlobal = function () {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    throw new Error('unable to locate global object');
};
//@ts-ignore
let AbortController = typeof getGlobal().AbortController === 'undefined' ? cjs_ponyfill_1.AbortController : getGlobal().AbortController;
exports.AbortController = AbortController;
//@ts-ignore
let AbortSignal = typeof getGlobal().AbortController === 'undefined' ? cjs_ponyfill_1.AbortSignal : getGlobal().AbortSignal;
exports.AbortSignal = AbortSignal;
